export const sumUp = (arr: any[], identifier?: string) =>
	arr
		.map((item) => (undefined === identifier ? item : parseInt(item[identifier], 10)))
		.reduce((partialSum, a) => partialSum + a, 0);
